type GTMConfig = {
    gtmId: string;
    dataLayerName?: string;
};

/**
 * Interface for window with data layer
 */
type WindowWithDataLayer = Record<string, unknown> & Window;

const initializedGTMContainers = new Set<string>();

const isGTMInitialized = (id: string) => {
    return initializedGTMContainers.has(id);
};

const markGTMAsInitialized = (id: string) => {
    initializedGTMContainers.add(id);
};

export const initGTM = ({ gtmId, dataLayerName = "wppopen_dataLayer" }: GTMConfig) => {
    if (isGTMInitialized(gtmId)) {
        console.info(`GTM container ${gtmId} already initialized, skipping.`);
        return;
    }

    // Initialize the data layer
    const windowWithDataLayer = window as unknown as WindowWithDataLayer;
    windowWithDataLayer[dataLayerName] = windowWithDataLayer[dataLayerName] ?? [];

    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','${dataLayerName}','${gtmId}');`;

    if (document.head.firstChild) {
        document.head.insertBefore(script, document.head.firstChild);
    } else {
        document.head.appendChild(script);
    }

    markGTMAsInitialized(gtmId);
};
